module.exports = __webpack_public_path__ + "img/beianico.d0289dc0.png";